
const tileactions = state => state.tileactions;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const entities = state=> state.listdata.lists.entities
const companies = state=> state.listdata.lists.companies
const adresses = state=> state.listdata.lists.adresses
const projects = state=> state.listdata.lists.projects



export default {
  tileactions,
  data,
  dataobject,
  entities,
  companies,
  adresses,
  projects

};